var map = {
	"./AUD.png": "9b17",
	"./CAD.png": "ec35",
	"./CHF.png": "1229",
	"./CNY.png": "2777",
	"./DKK.png": "7203",
	"./EUR.png": "3bda",
	"./GBP.png": "01c9",
	"./HKD.png": "3a20",
	"./JPY.png": "a1a8",
	"./NOK.png": "80b7",
	"./NZD.png": "4445",
	"./SEK.png": "0dce",
	"./SGD.png": "895a",
	"./USD.png": "9799"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9a35";